module.exports = __webpack_public_path__ + "img/17318187.0decb058.png";